'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('../../../forms/text');

var _text2 = _interopRequireDefault(_text);

var _spinner = require('../../../spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _listLocal = require('./list.local.css');

var _listLocal2 = _interopRequireDefault(_listLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ListItem = function (_React$Component) {
  _inherits(ListItem, _React$Component);

  function ListItem(props) {
    _classCallCheck(this, ListItem);

    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

    _this.blurOnEnterPress = function (e) {
      if (_this.state.editing && e.keyCode === 13) {
        _this.leaveEditingState(e);
      }
    };

    _this.toggleEditingState = function (e) {
      e.preventDefault();

      if (_this.props.onEditClick) {
        _this.props.onEditClick();

        return;
      }

      _this.setState(function (prevState) {
        return {
          editing: !prevState.editing
        };
      });
    };

    _this.leaveEditingState = function (e) {
      _this.toggleEditingState(e); // Only trigger change if value was actually modified.


      if (_this.state.value !== _this.props.value) {
        _this.props.onBlur(_this.state.value);
      }
    };

    _this.state = {
      editing: false,
      value: props.value
    };
    return _this;
  }

  _createClass(ListItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.blurOnEnterPress) {
        window.addEventListener('keypress', this.blurOnEnterPress);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(function () {
        return {
          value: !nextProps.value ? 'n/a' : nextProps.value
        };
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keypress', this.blurOnEnterPress);
    }
    /*
     * Switches between read only mode and an input
     * if `this.props.editable` is true
     */

    /*
     * When in editing mode, we are going to save values
     * onBlur. This flips back to read only mode and lets the
     * parent component handle the value.
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          value = _props.value,
          editableText = _props.editableText,
          editable = _props.editable;
      var listContent = void 0;

      if (this.state.editing) {
        listContent = _react2.default.createElement(_text2.default, {
          theme: 'classic',
          autoFocus: true,
          name: this.props.label,
          onBlur: this.leaveEditingState,
          onChange: function onChange(_ref) {
            var target = _ref.target;
            return _this2.setState(function () {
              return {
                value: target.value
              };
            });
          },
          onClick: function onClick() {},
          value: this.state.value === 'n/a' ? '' : this.state.value,
          wrapperClassname: _listLocal2.default.inputOverride
        });
      } else {
        var anchor = void 0;

        if (editable) {
          anchor = _react2.default.createElement('button', {
            onFocus: !this.props.onEditClick ? this.toggleEditingState : undefined,
            onBlur: !this.props.onEditClick ? this.toggleEditingState : undefined,
            onClick: this.toggleEditingState,
            className: _listLocal2.default.anchor
          }, editableText);
        }

        var editableValue = 'n/a';

        if (this.props.loading) {
          editableValue = _react2.default.createElement(_spinner2.default, {
            size: 'small'
          });
        } else if (value) {
          editableValue = value;
        }

        listContent = editable ? _react2.default.createElement('span', {
          className: _listLocal2.default.listItemValue
        }, _react2.default.createElement('span', {
          className: _listLocal2.default.value
        }, editableValue), anchor) : _react2.default.createElement('span', {
          className: _listLocal2.default.listItemValue
        }, _react2.default.createElement('span', {
          className: _listLocal2.default.value
        }, !value ? 'n/a' : value));
      }

      return _react2.default.createElement('li', {
        className: _listLocal2.default.listItem
      }, _react2.default.createElement('span', {
        className: _listLocal2.default.label
      }, label), listContent);
    }
  }]);

  return ListItem;
}(_react2.default.Component);

ListItem.propTypes = {
  /**
   * Left hand label
   */
  label: _propTypes2.default.node.isRequired,

  /**
   * Right side displayed value
   */
  value: _propTypes2.default.any,

  /**
   * Anchor-like text for allowing user to edit field
   */
  editableText: _propTypes2.default.string,

  /**
   * States if this field is editable or not
   */
  editable: _propTypes2.default.bool,

  /**
   * When editing finishes, onBlur is called with new value
   */
  onBlur: _propTypes2.default.func,

  /**
   * Shows a loading spinner for the value
   */
  loading: _propTypes2.default.bool,

  /**
   * Fires a blur event when enter is pressed
   */
  blurOnEnterPress: _propTypes2.default.bool,

  /**
   * Optional function to be called in place of internal editing
   */
  onEditClick: _propTypes2.default.func
};
ListItem.defaultProps = {
  blurOnEnterPress: true,
  editableText: 'Edit',
  onEditClick: undefined
};
exports.default = ListItem;